import type { OnPageTransitionStartAsync } from "vike/types";
import { pageQueryToPageDetails } from "@/utils/pageQueryToPageDetails";
import { parseQueryParamsFromUrl } from "@/utils/queryParams";
import { routerEventEmitter } from "@/services/router/routerEventEmitter";
import type { QueryParamsObj } from "@/types/UrlQueries";

export const onPageTransitionStart: OnPageTransitionStartAsync = async (pageContext) => {
	const query = parseQueryParamsFromUrl(pageContext.urlOriginal);
	const { internalPageName } = pageQueryToPageDetails(query as QueryParamsObj);
	console.info(`Page transition start: ${internalPageName}`);

	document.body.classList.add("page-transitioning");

	routerEventEmitter.emit("TransitionStart", pageContext.urlOriginal, internalPageName);
};
